export interface ComparisonRow {
  without: string
  with: string
}

export const comparisonRows: ComparisonRow[] = [
  {
    without: '100+ hours yearly spent planning',
    with: '10 minutes per week · Everything ready',
  },
  {
    without: 'Improvised lessons · No progression',
    with: '300+ structured sessions · Logical progression',
  },
  {
    without: 'Student improvement: slow & unclear',
    with: 'Measurable progress · Clear advancement',
  },
  {
    without: 'Parents asking "Where are the results?"',
    with: 'Evaluation sheets & progress reports ready',
  },
  {
    without: 'Entering class unprepared',
    with: 'Every session mapped · Ready to teach',
  },
]

export const problems: string[] = [
  'You spend 3+ hours every week creating lesson plans from scratch',
  'You run out of ideas and repeat the same exercises over and over',
  "You don't know how to structure a logical progression for the entire year",
  "Student retention is terrible because they don't see a clear path",
  'You feel unprepared and stressed before every class',
  "You're trading your creative energy for administrative burnout",
]
